import Divider from 'tio-ui/components/divider';
import PageHero from 'tio-ui/components/page-hero';
import { HStack, Section, VStack } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import { PhThumbsUp, PhMedal, PhTrophy } from 'ember-phosphor-icons';
<template>
  <VStack>
    <PageHero
      @icon={{PhTrophy}}
      @title={{t "planning_for_college.scholarship.hero_title"}}
      @subtitle={{t "planning_for_college.scholarship.hero_detail"}}
      @gradient="brand"
      @decoration="circles"
    />
    <Section>
      <:body>
        <Section>
          {{! Search text & button }}
          <p class="pb-12 pt-6 font-semibold">
            {{t "planning_for_college.scholarship.learn_about" htmlSafe=true}}
          </p>
          <div class="tio-flex-center">
            <a
              class="tio-row-flush tio-bg-info tio-fg-inverse px-6 py-2 rounded-lg"
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.lendkey.com/scholarship-search/?sk=AFF-Tuitionio&utm_source=AFF-Tuitionio&utm_medium=referral&utm_campaign=AFF"
            >
              {{t "planning_for_college.scholarship.search_button" htmlSafe=true}}
            </a>
          </div>

          {{! Pros of a scholarship section }}
          <Section>
            <:header>
              {{t "planning_for_college.scholarship.pros_scholarship"}}
            </:header>
            <:body>
              <HStack>
                <div class="tio-place-center">
                  <PhThumbsUp @size="24" class="flex-none tio-fg-info" />
                  <p class="text-center text-lg">
                    {{t "planning_for_college.scholarship.pro_1"}}
                  </p>
                </div>
                <div class="tio-place-center">
                  <PhMedal @size="24" class="flex-none tio-fg-info" />
                  <p class="text-center text-lg">
                    {{t "planning_for_college.scholarship.pro_2"}}
                  </p>
                </div>
              </HStack>
            </:body>
          </Section>
        </Section>

        {{! cons of a scholarship section }}
        <Section>
          <:header>
            {{t "planning_for_college.scholarship.cons_scholarship"}}
          </:header>
          <:body>
            {{t "planning_for_college.scholarship.con_1"}}
          </:body>
        </Section>

        {{! How to apply section }}
        <Section>
          <:header>
            {{t "planning_for_college.scholarship.how_to_apply"}}
          </:header>
          <:body>
            {{! Step 1 - Search }}
            <div class="pt-10 flex flex-row">
              <div
                class="justify-self-center shrink-0 w-[31px] h-[31px] tio-bg-info tio-fg-inverse rounded-full text-center items-center leading-[31px]"
              >
                {{t "number_one"}}
              </div>
              <span class="ml-6 tio-text-xl-bold tio-fg-muted text-center">
                {{t "planning_for_college.scholarship.search" htmlSafe=true}}
              </span>
            </div>
            <div class="py-4 sm:px-10">
              <p class="px-12">
                {{t "planning_for_college.scholarship.learn_about" htmlSafe=true}}
              </p>
            </div>
            <Divider class="my-2" />

            {{! Step 2 - Apply }}
            <div class="pt-10 flex flex-row">
              <div
                class="justify-self-center shrink-0 w-[31px] h-[31px] tio-bg-info tio-fg-inverse rounded-full text-center items-center leading-[31px]"
              >
                {{t "number_two"}}
              </div>
              <div class="tio-row-flush ml-6 tio-text-xl-bold tio-fg-muted">
                {{t "planning_for_college.scholarship.apply" htmlSafe=true}}
              </div>
            </div>
            <div class="py-4 sm:px-10">
              <ul class="list-disc px-12">
                <li>
                  <p class="">
                    {{t "planning_for_college.scholarship.apply_li_1"}}
                  </p>
                </li>
                <li>
                  <p class="">
                    {{t "planning_for_college.scholarship.apply_li_2"}}
                  </p>
                </li>
              </ul>
            </div>
            <Divider class="my-2" />

            {{! Step 3 - Keep Up the Good Work }}
            <div class="pt-10 flex flex-row">
              <div
                class="justify-self-center shrink-0 w-[31px] h-[31px] tio-bg-info tio-fg-inverse rounded-full text-center items-center leading-[31px]"
              >
                {{t "number_three"}}
              </div>
              <span class="ml-6 tio-text-xl-bold tio-fg-muted text-center">
                {{t "planning_for_college.scholarship.keep_up" htmlSafe=true}}
              </span>
            </div>
            <div class="py-4">
              <p class="px-12">
                {{t "planning_for_college.scholarship.keep_up_detail"}}
              </p>
            </div>
          </:body>
        </Section>
      </:body>
    </Section>
  </VStack>
</template>
